module.exports = __webpack_public_path__ + "static/media/咖哩雞肉燴飯.53f3e657.jpg";